import { useEffect, useState, useRef } from "react";
import api from "../../api/client";
import { useAuth } from "../../context/AuthContext";
import { PLANTILLAS as PLANTILLAS_MAP, PlantillaClasica, FUENTES, FUENTES_URL } from "../../components/Plantillas";

const PLANTILLAS = [
  { id: "clasica", label: "Clásica", desc: "Limpia y profesional, fondo blanco", emoji: "🏛️" },
  { id: "moderna", label: "Moderna", desc: "Oscura con acentos vibrantes", emoji: "🌙" },
  { id: "elegante", label: "Elegante", desc: "Minimalista y premium", emoji: "💎" },
  { id: "colorida", label: "Colorida", desc: "Festiva, perfecta para restaurantes", emoji: "🎨" },
  { id: "delivery", label: "Delivery", desc: "Estilo app de pedidos, grid con fotos", emoji: "🛵" },
  { id: "acordeon", label: "Acordeón", desc: "Hero de marca + categorías desplegables", emoji: "📋" },
  { id: "tienda",   label: "Tienda",   desc: "App móvil: grid 2 col con categorías", emoji: "🛍️" },
];

const DIAS = ["lunes", "martes", "miercoles", "jueves", "viernes", "sabado", "domingo"];
const TABS_BASE = ["General", "Horarios", "Pagos y WhatsApp", "Redes sociales", "País y Moneda"];
const TABS_VES  = ["General", "Horarios", "Pagos y WhatsApp", "Redes sociales", "Tasa BCV", "País y Moneda"];

const PAISES_CONFIG = [
  "Venezuela", "Colombia", "México", "Argentina", "Chile", "Perú",
  "Ecuador", "Bolivia", "Uruguay", "Paraguay", "Panamá", "Costa Rica",
  "Guatemala", "Honduras", "El Salvador", "Nicaragua", "República Dominicana",
  "Cuba", "Puerto Rico", "España", "Estados Unidos", "Otro",
];

const PAISES_MONEDAS_CONFIG = {
  "Venezuela": "VES", "Colombia": "COP", "México": "MXN",
  "Argentina": "ARS", "Chile": "CLP", "Perú": "PEN",
  "Ecuador": "USD", "Bolivia": "BOB", "Uruguay": "UYU",
  "Paraguay": "PYG", "Panamá": "USD", "Costa Rica": "CRC",
  "Guatemala": "GTQ", "Honduras": "HNL", "El Salvador": "USD",
  "Nicaragua": "NIO", "República Dominicana": "DOP", "Cuba": "CUP",
  "Puerto Rico": "USD", "España": "EUR", "Estados Unidos": "USD",
  "Otro": "USD",
};

const MONEDAS_DISPONIBLES = [
  { code: "USD", label: "USD — Dólar estadounidense ($)" },
  { code: "VES", label: "VES — Bolívar venezolano (Bs.)" },
  { code: "COP", label: "COP — Peso colombiano ($)" },
  { code: "MXN", label: "MXN — Peso mexicano ($)" },
  { code: "ARS", label: "ARS — Peso argentino ($)" },
  { code: "CLP", label: "CLP — Peso chileno ($)" },
  { code: "PEN", label: "PEN — Sol peruano (S/)" },
  { code: "BOB", label: "BOB — Boliviano (Bs.)" },
  { code: "UYU", label: "UYU — Peso uruguayo ($U)" },
  { code: "PYG", label: "PYG — Guaraní (₲)" },
  { code: "CRC", label: "CRC — Colón costarricense (₡)" },
  { code: "GTQ", label: "GTQ — Quetzal (Q)" },
  { code: "HNL", label: "HNL — Lempira hondureño (L)" },
  { code: "NIO", label: "NIO — Córdoba nicaragüense (C$)" },
  { code: "DOP", label: "DOP — Peso dominicano (RD$)" },
  { code: "CUP", label: "CUP — Peso cubano ($)" },
  { code: "EUR", label: "EUR — Euro (€)" },
];

const DEMO_CATS = [
  { id: 1, nombre: "Más pedidos", productos: [
    { id: 1, nombre: "Especial del día",  precio: 9.99,  foto_url: null, descripcion: "Delicioso y fresco", variantes: [], precio_promocion: null },
    { id: 2, nombre: "Combo Popular",     precio: 14.50, foto_url: null, descripcion: null, variantes: [], precio_promocion: null },
    { id: 3, nombre: "Favorito",          precio: 7.99,  foto_url: null, descripcion: null, variantes: [], precio_promocion: null },
    { id: 4, nombre: "Premium Mix",       precio: 19.90, foto_url: null, descripcion: null, variantes: [], precio_promocion: null },
  ]},
];
const MOCK_CARRITO = { items: [], agregar: () => {}, quitar: () => {}, vaciar: () => {}, total: 0, count: 0 };

/* ─── Simulador: usa las plantillas reales escaladas ──────────────────────── */
const SCALE = 228 / 375; // inner phone width (240 - 6*2 border) / template width

function SimuladorPlantilla({ nombre, descripcion, color, plantilla, logoUrl, bannerUrl, productos, fuente }) {
  const cats = productos && productos.length > 0
    ? [{ id: 1, nombre: "Destacados", productos: productos.slice(0, 6) }]
    : DEMO_CATS;

  const mockMenu = {
    config: {
      nombre_comercio: nombre || 'Mi Tienda',
      descripcion: descripcion || '',
      color_tema: color,
      fuente_nombre: fuente || null,
      logo_url: logoUrl || null,
      banner_url: bannerUrl || null,
    },
    tenant: { nombre_tienda: nombre || 'Mi Tienda' },
    categorias: cats,
  };
  const Plantilla = PLANTILLAS_MAP[plantilla] || PlantillaClasica;
  return (
    <div style={{ transformOrigin: 'top left', transform: `scale(${SCALE})`, width: 375, pointerEvents: 'none' }}>
      <Plantilla
        menu={mockMenu}
        color={color}
        tasa={null}
        catsFiltradas={cats}
        carrito={MOCK_CARRITO}
        busqueda=''
        setBusqueda={() => {}}
        catSeleccionada={null}
        setCatSeleccionada={() => {}}
        onOpenCart={() => {}}
      />
    </div>
  );
}

/* ─── Marco de celular ────────────────────────────────────────────────────── */
function PhoneFrame({ children, plantilla, color }) {
  const frames = {
    clasica:  { border: "#9ca3af", bg: "#e5e7eb", notch: "#9ca3af" },
    moderna:  { border: "#1e293b", bg: "#0f172a",  notch: "#1e293b" },
    elegante: { border: "#c4b5a0", bg: "#e7e0d8",  notch: "#c4b5a0" },
    colorida: { border: color,     bg: color,       notch: color },
    delivery: { border: "#374151", bg: "#1f2937",   notch: "#374151" },
    acordeon: { border: color,     bg: `${color}dd`, notch: color },
    tienda:   { border: "#9ca3af", bg: "#f4f4f8",    notch: "#9ca3af" },
  };
  const f = frames[plantilla] || frames.clasica;
  return (
    <div className="flex flex-col items-center">
      <div
        style={{
          width: 240,
          height: 480,
          borderRadius: 32,
          border: `6px solid ${f.border}`,
          background: f.bg,
          boxShadow: "0 20px 60px rgba(0,0,0,0.25), inset 0 0 0 1px rgba(255,255,255,0.08)",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div style={{
          position: "absolute", top: 0, left: "50%", transform: "translateX(-50%)",
          width: 56, height: 14, background: f.notch,
          borderRadius: "0 0 10px 10px", zIndex: 20,
        }} />
        <style>{`.phone-sim-inner::-webkit-scrollbar { display: none; }`}</style>
        <div className="phone-sim-inner" style={{ width: "100%", height: "100%", overflowY: "auto", overflowX: "hidden", scrollbarWidth: "none", msOverflowStyle: "none" }}>
          {children}
        </div>
      </div>
      <div style={{ width: 48, height: 4, background: f.border, borderRadius: 2, marginTop: 8 }} />
      <p className="text-xs text-gray-400 mt-2 text-center">Vista previa del catálogo</p>
    </div>
  );
}

/* ─── Auto-resize imagen manteniendo proporciones ─────────────────────────── */
function resizeImagen(file, maxPx = 800) {
  return new Promise((resolve) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const ratio = Math.min(maxPx / img.naturalWidth, maxPx / img.naturalHeight, 1);
      const w = Math.round(img.naturalWidth * ratio);
      const h = Math.round(img.naturalHeight * ratio);
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      canvas.getContext("2d").drawImage(img, 0, 0, w, h);
      URL.revokeObjectURL(url);
      canvas.toBlob(resolve, "image/png", 0.92);
    };
    img.src = url;
  });
}

/* ─── Página principal ────────────────────────────────────────────────────── */
export default function Configuracion() {
  const { usuario } = useAuth();
  const esVenezuela = usuario?.moneda_local === "VES";
  const TABS = esVenezuela ? TABS_VES : TABS_BASE;
  const [tab, setTab] = useState("General");
  const [config, setConfig] = useState(null);
  const [productos, setProductos] = useState([]);
  const [plan, setPlan] = useState("gratis");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");
  const [previewForm, setPreviewForm] = useState(null);
  const logoRef = useRef();
  const bannerRef = useRef();

  useEffect(() => {
    Promise.all([
      api.get("/config/"),
      api.get("/productos/?page=1&page_size=6&solo_activos=true"),
      api.get("/suscripcion/"),
    ]).then(([cfg, prods, sus]) => {
      setConfig(cfg.data);
      setProductos(prods.data.items || []);
      setPlan(sus.data.plan || "gratis");
    }).finally(() => setLoading(false));
  }, []);

  const guardar = async (patch) => {
    setSaving(true);
    setMsg("");
    try {
      const { data } = await api.put("/config/", patch);
      setConfig(data);
      setPreviewForm(null);
      setMsg("¡Guardado correctamente!");
      setTimeout(() => setMsg(""), 3000);
    } catch {
      setMsg("Error al guardar");
    } finally {
      setSaving(false);
    }
  };

  const subirImagen = async (tipo, file) => {
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post(`/config/${tipo}`, fd);
      setConfig(data);
      setMsg("Imagen actualizada");
      setTimeout(() => setMsg(""), 3000);
    } catch {
      setMsg("Error al subir imagen");
    }
  };

  const handleSelectImagen = async (tipo, e) => {
    const file = e.target.files[0];
    if (!file) return;
    e.target.value = "";
    const blob = await resizeImagen(file, tipo === "logo" ? 800 : 1200);
    subirImagen(tipo, new File([blob], `${tipo}.png`, { type: "image/png" }));
  };

  const eliminarImagen = async (tipo) => {
    try {
      const { data } = await api.delete(`/config/${tipo}`);
      setConfig(data);
      setMsg(`${tipo === "logo" ? "Logo" : "Banner"} eliminado`);
      setTimeout(() => setMsg(""), 3000);
    } catch {
      setMsg("Error al eliminar");
    }
  };

  if (loading) return (
    <div className="flex items-center justify-center h-40">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
    </div>
  );

  const preview = previewForm || config;

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Configuración</h2>
        <p className="text-gray-500 text-sm mt-1">Personaliza tu catálogo digital</p>
      </div>

      {msg && (
        <div className={`mb-4 px-4 py-3 rounded-lg text-sm ${msg.includes("Error") ? "bg-red-50 text-red-700 border border-red-200" : "bg-green-50 text-green-700 border border-green-200"}`}>
          {msg}
        </div>
      )}

      {/* Tabs */}
      <div className="flex gap-1 bg-gray-100 rounded-xl p-1 mb-6 overflow-x-auto">
        {TABS.map((t) => (
          <button key={t} onClick={() => setTab(t)}
            className={`flex-shrink-0 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${tab === t ? "bg-white shadow text-indigo-700" : "text-gray-500 hover:text-gray-700"}`}>
            {t}
          </button>
        ))}
      </div>

      {/* Layout: form + simulador en tab General */}
      {tab === "General" ? (
        <div className="flex flex-col xl:flex-row gap-6">
          {/* Formulario */}
          <div className="flex-1 bg-white rounded-xl shadow-sm p-6">
            <GeneralTab
              config={config}
              plan={plan}
              onSave={guardar}
              logoRef={logoRef}
              bannerRef={bannerRef}
              onUpload={subirImagen}
              onSelectImagen={handleSelectImagen}
              onEliminar={eliminarImagen}
              saving={saving}
              onPreviewChange={setPreviewForm}
            />
          </div>

          {/* Simulador */}
          <div className="xl:w-72 flex flex-col items-center">
            <div className="bg-white rounded-xl shadow-sm p-6 w-full flex flex-col items-center sticky top-4">
              {/* URL del catálogo */}
              {usuario?.subdominio && (() => {
                const url = `${window.location.origin}/catalogo/${usuario.subdominio}`;
                return (
                  <div className="w-full mb-5 bg-indigo-50 border border-indigo-100 rounded-xl p-3">
                    <p className="text-xs font-semibold text-indigo-500 mb-1.5 uppercase tracking-wide">Tu catálogo</p>
                    <div className="flex items-center gap-2">
                      <a href={url} target="_blank" rel="noopener noreferrer"
                        className="flex-1 text-xs font-mono text-indigo-700 truncate hover:underline">
                        {url.replace(/^https?:\/\//, "")}
                      </a>
                      <button
                        onClick={() => { navigator.clipboard.writeText(url); }}
                        title="Copiar URL"
                        className="flex-shrink-0 text-indigo-400 hover:text-indigo-600 transition-colors"
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                );
              })()}
              <div className="flex items-center gap-2 mb-5 self-start">
                <span className="text-lg">📱</span>
                <h3 className="font-semibold text-gray-700 text-sm">Simulador en vivo</h3>
              </div>
              <PhoneFrame plantilla={preview?.plantilla || "clasica"} color={preview?.color_tema || "#3B82F6"}>
                <SimuladorPlantilla
                  nombre={preview?.nombre_comercio || ""}
                  descripcion={preview?.descripcion || ""}
                  color={preview?.color_tema || "#3B82F6"}
                  plantilla={preview?.plantilla || "clasica"}
                  logoUrl={config?.logo_url}
                  bannerUrl={config?.banner_url}
                  productos={productos}
                  fuente={preview?.fuente_nombre}
                />
              </PhoneFrame>
              <p className="text-xs text-gray-400 text-center mt-4 leading-relaxed">
                Los cambios se reflejan aquí<br />al guardar o al escribir
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm p-6">
          {tab === "Horarios" && <HorariosTab config={config} onSave={guardar} saving={saving} />}
          {tab === "Pagos y WhatsApp" && <PagosTab config={config} onSave={guardar} saving={saving} />}
          {tab === "Redes sociales" && <RedesTab config={config} onSave={guardar} saving={saving} />}
          {tab === "Tasa BCV" && esVenezuela && <TasaBCVTab config={config} onSave={guardar} />}
          {tab === "País y Moneda" && <PaisMonedaTab />}
        </div>
      )}
    </div>
  );
}

const PLANTILLAS_POR_PLAN = {
  gratis:      new Set(["clasica", "moderna"]),
  emprendedor: new Set(["clasica", "moderna", "elegante", "colorida", "delivery", "acordeon", "tienda"]),
  empresa:     new Set(["clasica", "moderna", "elegante", "colorida", "delivery", "acordeon", "tienda"]),
};

/* ─── Tab General ────────────────────────────────────────────────────────── */
function GeneralTab({ config, plan, onSave, logoRef, bannerRef, onUpload, onSelectImagen, onEliminar, saving, onPreviewChange }) {
  const [form, setForm] = useState({
    nombre_comercio: config?.nombre_comercio || "",
    descripcion: config?.descripcion || "",
    plantilla: config?.plantilla || "clasica",
    color_tema: config?.color_tema || "#3B82F6",
    fuente_nombre: config?.fuente_nombre || null,
  });

  const plantillasPermitidas = PLANTILLAS_POR_PLAN[plan] || PLANTILLAS_POR_PLAN.gratis;

  const update = (patch) => {
    const next = { ...form, ...patch };
    setForm(next);
    onPreviewChange(next);
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nombre del comercio</label>
          <input
            value={form.nombre_comercio}
            onChange={(e) => update({ nombre_comercio: e.target.value })}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            placeholder="Mi Tienda"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Color del tema</label>
          <div className="flex items-center gap-3">
            <input
              type="color"
              value={form.color_tema}
              onChange={(e) => update({ color_tema: e.target.value })}
              className="h-10 w-14 border border-gray-300 rounded-lg cursor-pointer p-1"
            />
            <span className="text-sm text-gray-500 font-mono">{form.color_tema}</span>
          </div>
        </div>
      </div>

      {/* ── Selector de tipo de letra ── */}
      <div>
        <link rel="stylesheet" href={FUENTES_URL} />
        <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de letra del nombre</label>
        <select
          value={form.fuente_nombre || ""}
          onChange={(e) => update({ fuente_nombre: e.target.value || null })}
          className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          <option value="">Por defecto (sin fuente especial)</option>
          {FUENTES.map((f) => (
            <option key={f.id} value={f.id}>{f.id} — {f.desc}</option>
          ))}
        </select>
        {form.fuente_nombre && (
          <div className="mt-2 px-3 py-2 bg-gray-50 rounded-lg border border-gray-200 text-center">
            <span
              className="text-xl font-bold text-gray-800"
              style={{ fontFamily: `'${form.fuente_nombre}', system-ui` }}
            >
              {form.nombre_comercio || "Mi Tienda"}
            </span>
            <span className="block text-xs text-gray-400 mt-0.5">{form.fuente_nombre}</span>
          </div>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Descripción del comercio</label>
        <textarea
          value={form.descripcion}
          onChange={(e) => update({ descripcion: e.target.value })}
          rows={2}
          className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-none"
          placeholder="Breve descripción de tu negocio"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-3">Plantilla del catálogo</label>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {PLANTILLAS.map((p) => {
            const bloqueada = !plantillasPermitidas.has(p.id);
            const seleccionada = form.plantilla === p.id;
            return (
              <button
                key={p.id}
                type="button"
                onClick={() => !bloqueada && update({ plantilla: p.id })}
                title={bloqueada ? "Disponible en plan Emprendedor o Empresa" : p.desc}
                className={`border-2 rounded-xl p-3 text-left transition-all relative
                  ${seleccionada ? "border-indigo-500 bg-indigo-50 shadow-md" : "border-gray-200"}
                  ${bloqueada ? "opacity-50 cursor-not-allowed" : "hover:border-gray-300 cursor-pointer"}`}
              >
                {bloqueada && (
                  <span className="absolute top-2 right-2 text-gray-400 text-xs">🔒</span>
                )}
                <div className="text-2xl mb-1">{p.emoji}</div>
                <div className="font-medium text-sm text-gray-800">{p.label}</div>
                <div className="text-xs text-gray-500 mt-0.5 leading-tight">{p.desc}</div>
                {seleccionada && !bloqueada && (
                  <div className="mt-2 text-xs font-semibold text-indigo-600">✓ Seleccionada</div>
                )}
                {bloqueada && (
                  <div className="mt-2 text-xs text-gray-400">Plan Emprendedor</div>
                )}
              </button>
            );
          })}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Logo</label>
          <p className="text-xs text-gray-400 mb-2">Recomendado: imagen cuadrada · mín. 300×300px · máx. 2MB</p>
          {config?.logo_url ? (
            <div className="flex items-center gap-3 mb-2">
              <img src={`${process.env.REACT_APP_API_URL || "http://localhost:8000"}${config.logo_url}`} alt="Logo"
                className="w-20 h-20 object-contain rounded-lg border bg-gray-50" />
              <button
                type="button"
                onClick={() => onEliminar("logo")}
                className="text-xs text-red-500 hover:text-red-700 flex items-center gap-1 border border-red-200 hover:border-red-300 px-2 py-1 rounded-lg"
              >
                ✕ Eliminar logo
              </button>
            </div>
          ) : null}
          <input
            ref={logoRef}
            type="file"
            accept="image/*"
            onChange={(e) => onSelectImagen("logo", e)}
            className="text-sm text-gray-500 file:mr-2 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:text-xs file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Banner / portada</label>
          <p className="text-xs text-gray-400 mb-2">Recomendado: 1200×300px (proporción 4:1) · JPG o PNG · máx. 2MB</p>
          {config?.banner_url ? (
            <div className="mb-2">
              <img src={`${process.env.REACT_APP_API_URL || "http://localhost:8000"}${config.banner_url}`} alt="Banner"
                className="w-full h-20 object-cover rounded-lg border mb-1" />
              <button
                type="button"
                onClick={() => onEliminar("banner")}
                className="text-xs text-red-500 hover:text-red-700 flex items-center gap-1 border border-red-200 hover:border-red-300 px-2 py-1 rounded-lg"
              >
                ✕ Eliminar banner
              </button>
            </div>
          ) : null}
          <input
            ref={bannerRef}
            type="file"
            accept="image/*"
            onChange={(e) => onSelectImagen("banner", e)}
            className="text-sm text-gray-500 file:mr-2 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:text-xs file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
          />
        </div>
      </div>

      <button
        onClick={() => onSave(form)}
        disabled={saving}
        className="bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-400 text-white px-6 py-2.5 rounded-lg text-sm font-medium"
      >
        {saving ? "Guardando..." : "Guardar cambios"}
      </button>
    </div>
  );
}

/* ─── Tab Horarios ───────────────────────────────────────────────────────── */
const ARROW_BTN = { background: "none", border: "none", cursor: "pointer", fontSize: 13, color: "#64748b", padding: "4px 10px", borderRadius: 6, lineHeight: 1 };

function TimePicker({ value, onChange, disabled }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const parts = (value || "08:00 AM").split(" ");
  const [hh, mm] = (parts[0] || "08:00").split(":").map(Number);
  const period = parts[1] || "AM";

  useEffect(() => {
    if (!open) return;
    const fn = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, [open]);

  const emit = (h, m, p) => onChange(`${String(h).padStart(2,"0")}:${String(m).padStart(2,"0")} ${p}`);
  const addH = (d) => { let h = hh + d; if (h > 12) h = 1; if (h < 1) h = 12; emit(h, mm, period); };
  const addM = (d) => { let m = mm + d; if (m >= 60) m = 0; if (m < 0) m = 55; emit(hh, m, period); };
  const togP = () => emit(hh, mm, period === "AM" ? "PM" : "AM");

  return (
    <div style={{ position: "relative" }} ref={ref}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => setOpen(!open)}
        style={{ display: "flex", alignItems: "center", gap: 8, background: open ? "#eff6ff" : "#fff", border: "1px solid #e2e8f0", borderRadius: 8, padding: "7px 12px", cursor: disabled ? "default" : "pointer", fontSize: 14, fontWeight: 500, color: "#374151" }}
      >
        {value || "08:00 AM"}
        <span style={{ fontSize: 15, color: "#94a3b8" }}>⏱</span>
      </button>
      {open && (
        <div style={{ position: "absolute", top: "calc(100% + 6px)", left: 0, zIndex: 200, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 14, padding: "16px 20px", boxShadow: "0 8px 32px rgba(0,0,0,0.12)", minWidth: 190 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, justifyContent: "center" }}>
            {[{ val: hh, up: () => addH(1), dn: () => addH(-1) }, null, { val: mm, up: () => addM(5), dn: () => addM(-5) }, null, { val: period, up: togP, dn: togP }].map((col, i) =>
              col === null ? (
                <span key={i} style={{ fontSize: 22, fontWeight: 700, color: "#94a3b8", marginBottom: 2 }}>:</span>
              ) : (
                <div key={i} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
                  <button type="button" onClick={col.up} style={ARROW_BTN}>▲</button>
                  <span style={{ fontSize: 22, fontWeight: 700, minWidth: 36, textAlign: "center" }}>
                    {typeof col.val === "number" ? String(col.val).padStart(2, "0") : col.val}
                  </span>
                  <button type="button" onClick={col.dn} style={ARROW_BTN}>▼</button>
                </div>
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const LABEL_DIA = { lunes: "Lunes", martes: "Martes", miercoles: "Miércoles", jueves: "Jueves", viernes: "Viernes", sabado: "Sábado", domingo: "Domingo" };

function HorariosTab({ config, onSave, saving }) {
  const [horarios, setHorarios] = useState(() => {
    const saved = config?.horarios || {};
    const result = {};
    DIAS.forEach((dia) => {
      result[dia] = (saved[dia] && typeof saved[dia] === "object")
        ? saved[dia]
        : { abierto: dia !== "domingo", apertura: "08:00 AM", cierre: "08:00 PM" };
    });
    return result;
  });

  const upd = (dia, patch) => setHorarios((h) => ({ ...h, [dia]: { ...h[dia], ...patch } }));

  return (
    <div className="space-y-4">
      <div className="bg-green-50 border border-green-100 rounded-xl p-4 flex gap-3">
        <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 text-green-600">⏱</div>
        <div>
          <p className="font-semibold text-gray-800 text-sm">Horario de atención</p>
          <p className="text-gray-500 text-xs mt-0.5">Define los días que abres y la hora de apertura/cierre. Los días marcados como cerrados no se mostrarán como disponibles en el catálogo.</p>
        </div>
      </div>

      <div className="space-y-2">
        {DIAS.map((dia) => {
          const h = horarios[dia];
          return (
            <div key={dia} className={`flex items-center gap-3 px-4 py-3 rounded-xl border ${h.abierto ? "bg-white border-gray-200" : "bg-gray-50 border-gray-100"}`}>
              <span className="w-24 text-sm font-semibold text-gray-700">{LABEL_DIA[dia]}</span>
              <span className={`text-xs font-bold px-2.5 py-0.5 rounded-full ${h.abierto ? "bg-green-100 text-green-700" : "bg-red-100 text-red-600"}`}>
                {h.abierto ? "ABIERTO" : "CERRADO"}
              </span>
              <div className="flex-1 flex items-center gap-2">
                {h.abierto && (
                  <>
                    <TimePicker value={h.apertura} onChange={(v) => upd(dia, { apertura: v })} />
                    <span className="text-gray-400 text-lg">—</span>
                    <TimePicker value={h.cierre} onChange={(v) => upd(dia, { cierre: v })} />
                  </>
                )}
              </div>
              <button
                type="button"
                onClick={() => upd(dia, { abierto: !h.abierto })}
                style={{ width: 48, height: 26, borderRadius: 13, border: "none", cursor: "pointer", background: h.abierto ? "#3b82f6" : "#d1d5db", position: "relative", transition: "background 0.2s", flexShrink: 0 }}
              >
                <div style={{ position: "absolute", top: 3, left: h.abierto ? 25 : 3, width: 20, height: 20, borderRadius: "50%", background: "#fff", boxShadow: "0 1px 4px rgba(0,0,0,0.2)", transition: "left 0.2s" }} />
              </button>
            </div>
          );
        })}
      </div>

      <button onClick={() => onSave({ horarios })} disabled={saving}
        className="bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-400 text-white px-6 py-2.5 rounded-lg text-sm font-medium">
        {saving ? "Guardando..." : "Guardar horarios"}
      </button>
    </div>
  );
}

/* ─── Tab Pagos y WhatsApp ───────────────────────────────────────────────── */
function PagosTab({ config, onSave, saving }) {
  const [formas, setFormas] = useState(config?.formas_pago || {});
  const [wp, setWp] = useState(config?.whatsapp_config || { nombre: "", telefono: "", mensaje_personalizado: "" });

  const FORMAS_PAGO = [
    { key: "efectivo", label: "Efectivo" },
    { key: "transferencia", label: "Transferencia bancaria" },
    { key: "pago_movil", label: "Pago móvil" },
    { key: "zelle", label: "Zelle" },
    { key: "paypal", label: "PayPal" },
    { key: "binance", label: "Binance Pay" },
    { key: "tarjeta", label: "Tarjeta de crédito/débito" },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h3 className="font-medium text-gray-800 mb-3">Formas de pago aceptadas</h3>
        <div className="grid grid-cols-2 gap-2">
          {FORMAS_PAGO.map(({ key, label }) => (
            <label key={key} className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" checked={!!formas[key]}
                onChange={() => setFormas((p) => ({ ...p, [key]: !p[key] }))}
                className="rounded border-gray-300 text-indigo-600" />
              <span className="text-sm text-gray-700">{label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="border-t pt-5">
        <h3 className="font-medium text-gray-800 mb-1">Configuración de WhatsApp</h3>
        <p className="text-xs text-gray-500 mb-3">Los pedidos se enviarán a este número</p>
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Nombre del vendedor</label>
              <input value={wp.nombre} onChange={(e) => setWp({ ...wp, nombre: e.target.value })}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="Tu nombre" />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Teléfono (con código país)</label>
              <input value={wp.telefono} onChange={(e) => setWp({ ...wp, telefono: e.target.value })}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="+584121234567" />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Mensaje personalizado (opcional)</label>
            <textarea value={wp.mensaje_personalizado} onChange={(e) => setWp({ ...wp, mensaje_personalizado: e.target.value })}
              rows={2} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-none"
              placeholder="Hola! Quiero hacer este pedido..." />
          </div>
        </div>
      </div>

      <button onClick={() => onSave({ formas_pago: formas, whatsapp_config: wp })} disabled={saving}
        className="bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-400 text-white px-6 py-2.5 rounded-lg text-sm font-medium">
        {saving ? "Guardando..." : "Guardar configuración"}
      </button>
    </div>
  );
}

/* ─── Tab Redes sociales ─────────────────────────────────────────────────── */
function RedesTab({ config, onSave, saving }) {
  const [redes, setRedes] = useState(config?.redes_sociales || {});

  const REDES = [
    { key: "instagram", label: "Instagram", placeholder: "https://instagram.com/tutienda" },
    { key: "facebook", label: "Facebook", placeholder: "https://facebook.com/tutienda" },
    { key: "tiktok", label: "TikTok", placeholder: "https://tiktok.com/@tutienda" },
    { key: "twitter", label: "X / Twitter", placeholder: "https://twitter.com/tutienda" },
    { key: "youtube", label: "YouTube", placeholder: "https://youtube.com/@tutienda" },
    { key: "website", label: "Sitio web", placeholder: "https://tutienda.com" },
  ];

  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-500">Agrega los enlaces de tus redes sociales</p>
      {REDES.map(({ key, label, placeholder }) => (
        <div key={key}>
          <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
          <input value={redes[key] || ""} onChange={(e) => setRedes({ ...redes, [key]: e.target.value })}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            placeholder={placeholder} />
        </div>
      ))}
      <button onClick={() => onSave({ redes_sociales: redes })} disabled={saving}
        className="bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-400 text-white px-6 py-2.5 rounded-lg text-sm font-medium">
        {saving ? "Guardando..." : "Guardar redes sociales"}
      </button>
    </div>
  );
}

/* ─── Tab Tasa BCV ───────────────────────────────────────────────────────── */
function TasaBCVTab({ config, onSave }) {
  const [tasas, setTasas] = useState(null);
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actualizando, setActualizando] = useState(false);
  const [error, setError] = useState("");
  const [monedaBCV, setMonedaBCV] = useState(config?.moneda_bcv || "");
  const [tasaPersonalizada, setTasaPersonalizada] = useState(config?.tasa_bcv ? String(config.tasa_bcv) : "");
  const [fechaConsulta, setFechaConsulta] = useState("");
  const [resultadoFecha, setResultadoFecha] = useState(null);
  const [errorFecha, setErrorFecha] = useState("");
  const [buscandoFecha, setBuscandoFecha] = useState(false);

  const fmtFecha = (f) => {
    if (!f) return "";
    const [y, m, d] = f.split("-");
    const meses = ["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"];
    return `${parseInt(d)} ${meses[parseInt(m)-1]} ${y}`;
  };

  const cargar = async () => {
    try {
      const [u, h] = await Promise.all([
        api.get("/tasas/ultima").catch(() => null),
        api.get("/tasas/historial").catch(() => ({ data: [] })),
      ]);
      setTasas(u?.data || null);
      setHistorial(h.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { cargar(); }, []);

  const consultarPorFecha = async () => {
    if (!fechaConsulta) return;
    setBuscandoFecha(true);
    setResultadoFecha(null);
    setErrorFecha("");
    try {
      const { data } = await api.get(`/tasas/por-fecha/${fechaConsulta}`);
      setResultadoFecha(data);
    } catch (e) {
      setErrorFecha(e.response?.data?.detail || "No se encontró tasa para esa fecha");
    } finally {
      setBuscandoFecha(false);
    }
  };

  const guardarMoneda = async (valor) => {
    setMonedaBCV(valor);
    await onSave({ moneda_bcv: valor || null });
  };

  const actualizar = async (manual = null) => {
    if (manual) {
      try {
        const { data } = await api.put("/tasas/manual", manual);
        setTasas(data);
      } catch (e) {
        setError(e.response?.data?.detail || "Error al guardar");
      }
      return;
    }
    setActualizando(true);
    setError("");
    try {
      const { data } = await api.post("/tasas/actualizar");
      setTasas(data);
      await cargar();
    } catch (e) {
      setError(e.response?.data?.detail || "No se pudo conectar con el BCV");
    } finally {
      setActualizando(false);
    }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h3 className="font-semibold text-gray-800 mb-1">Tasa de cambio BCV</h3>
          <p className="text-sm text-gray-500">
            Se obtiene automáticamente cada día a las 12:00 AM desde el Banco Central de Venezuela.
          </p>
        </div>
        <button
          onClick={() => actualizar()}
          disabled={actualizando}
          className="flex-shrink-0 flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-300 text-white text-sm font-medium px-4 py-2 rounded-lg transition-colors"
        >
          {actualizando
            ? <><span className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin inline-block" /> Actualizando...</>
            : "Actualizar ahora"}
        </button>
      </div>

      {error && (
        <div className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-3">{error}</div>
      )}

      {/* Tasas actuales */}
      {loading ? (
        <div className="flex justify-center py-8"><div className="w-7 h-7 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" /></div>
      ) : tasas ? (
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-green-50 border border-green-200 rounded-xl p-5">
            <p className="text-xs text-green-600 font-semibold uppercase tracking-wide mb-1">Dólar USD</p>
            <p className="text-3xl font-black text-green-700">
              {tasas.usd?.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </p>
            <p className="text-xs text-green-500 mt-1">Bs. por $1 USD</p>
            <p className="text-xs text-gray-400 mt-3">Fecha valor: {fmtFecha(tasas.fecha)}</p>
          </div>
          <div className="bg-blue-50 border border-blue-200 rounded-xl p-5">
            <p className="text-xs text-blue-600 font-semibold uppercase tracking-wide mb-1">Euro EUR</p>
            <p className="text-3xl font-black text-blue-700">
              {tasas.eur?.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </p>
            <p className="text-xs text-blue-500 mt-1">Bs. por €1 EUR</p>
            <p className="text-xs text-gray-400 mt-3">Fecha valor: {fmtFecha(tasas.fecha)}</p>
          </div>
        </div>
      ) : (
        <div className="bg-gray-50 border border-dashed border-gray-300 rounded-xl p-6 text-center">
          <p className="text-sm text-gray-400">Sin tasas registradas. Presiona "Actualizar ahora" para obtener la tasa del BCV.</p>
        </div>
      )}

      {/* Configuracion de equivalencia */}
      <div className="border border-gray-200 rounded-xl p-5">
        <h4 className="font-semibold text-gray-700 text-sm mb-1">Equivalencia en bolívares</h4>
        <p className="text-xs text-gray-400 mb-4">Selecciona qué tasa usar para mostrar el precio en Bs. junto al precio en USD en tu catálogo público.</p>
        <div className="space-y-2">
          {[
            { valor: "", label: "No mostrar equivalencia", desc: "Solo se muestra el precio en USD" },
            { valor: "usd", label: "Tasa Dólar (USD)", desc: tasas ? `1 USD = Bs. ${tasas.usd?.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : "Tasa del BCV" },
            { valor: "eur", label: "Tasa Euro (EUR)", desc: tasas ? `1 EUR = Bs. ${tasas.eur?.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : "Tasa del BCV" },
          ].map(({ valor, label, desc }) => (
            <label key={valor} className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${monedaBCV === valor ? "border-indigo-500 bg-indigo-50" : "border-gray-200 hover:bg-gray-50"}`}>
              <input type="radio" name="moneda_bcv" checked={monedaBCV === valor} onChange={() => guardarMoneda(valor)} className="accent-indigo-600" />
              <div>
                <p className={`text-sm font-semibold ${monedaBCV === valor ? "text-indigo-700" : "text-gray-700"}`}>{label}</p>
                <p className="text-xs text-gray-400">{desc}</p>
              </div>
            </label>
          ))}

          {/* Opcion tasa personalizada */}
          <div className={`p-3 rounded-lg border transition-colors ${monedaBCV === "manual" ? "border-indigo-500 bg-indigo-50" : "border-gray-200"}`}>
            <label className="flex items-center gap-3 cursor-pointer">
              <input type="radio" name="moneda_bcv" checked={monedaBCV === "manual"} onChange={() => guardarMoneda("manual")} className="accent-indigo-600" />
              <div>
                <p className={`text-sm font-semibold ${monedaBCV === "manual" ? "text-indigo-700" : "text-gray-700"}`}>Tasa personalizada</p>
                <p className="text-xs text-gray-400">Ingresa la tasa manualmente cuando el BCV no esté disponible</p>
              </div>
            </label>
            {monedaBCV === "manual" && (
              <div className="mt-3 flex items-center gap-2 ml-7">
                <span className="text-sm text-gray-500 whitespace-nowrap">Bs. por $1</span>
                <input
                  type="number" step="0.01" min="0"
                  value={tasaPersonalizada}
                  onChange={(e) => setTasaPersonalizada(e.target.value)}
                  onBlur={async (e) => {
                    const v = parseFloat(e.target.value);
                    if (v > 0) await onSave({ tasa_bcv: v, moneda_bcv: "manual" });
                  }}
                  className="w-36 border border-gray-300 rounded-lg px-3 py-1.5 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  placeholder="517.96"
                  autoFocus
                />
                <span className="text-xs text-gray-400">Se guarda al salir del campo</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Consulta por fecha */}
      <div className="border border-gray-200 rounded-xl p-5">
        <h4 className="font-semibold text-gray-700 text-sm mb-1">Consultar tasa por fecha</h4>
        <p className="text-xs text-gray-400 mb-3">Busca la tasa del Banco Central registrada en una fecha específica.</p>
        <div className="flex gap-2">
          <input
            type="date"
            value={fechaConsulta}
            max={new Date().toISOString().split("T")[0]}
            onChange={(e) => { setFechaConsulta(e.target.value); setResultadoFecha(null); setErrorFecha(""); }}
            className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
          <button
            onClick={consultarPorFecha}
            disabled={!fechaConsulta || buscandoFecha}
            className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-300 text-white text-sm font-medium px-4 py-2 rounded-lg transition-colors whitespace-nowrap"
          >
            {buscandoFecha
              ? <><span className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin inline-block" /> Buscando...</>
              : "Consultar"}
          </button>
        </div>

        {errorFecha && (
          <p className="text-xs text-red-500 mt-2">{errorFecha}</p>
        )}

        {resultadoFecha && (
          <div className="mt-3 grid grid-cols-2 gap-3">
            <div className="bg-green-50 border border-green-200 rounded-lg px-4 py-3">
              <p className="text-xs text-green-600 font-semibold mb-1">Dólar USD — {fmtFecha(resultadoFecha.fecha)}</p>
              <p className="text-2xl font-black text-green-700">
                {resultadoFecha.usd?.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                <span className="text-xs font-normal text-green-500 ml-1">Bs./$</span>
              </p>
            </div>
            <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-3">
              <p className="text-xs text-blue-600 font-semibold mb-1">Euro EUR — {fmtFecha(resultadoFecha.fecha)}</p>
              <p className="text-2xl font-black text-blue-700">
                {resultadoFecha.eur?.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                <span className="text-xs font-normal text-blue-500 ml-1">Bs./€</span>
              </p>
            </div>
          </div>
        )}
      </div>

      {/* Historial */}
      {historial.length > 1 && (
        <div>
          <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Historial reciente</p>
          <div className="border border-gray-200 rounded-xl overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 text-gray-400 text-xs uppercase">
                <tr>
                  <th className="px-4 py-2 text-left">Fecha</th>
                  <th className="px-4 py-2 text-right">USD</th>
                  <th className="px-4 py-2 text-right">EUR</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {historial.slice(0, 7).map((t) => (
                  <tr key={t.fecha} className="hover:bg-gray-50">
                    <td className="px-4 py-2 text-gray-600">{fmtFecha(t.fecha)}</td>
                    <td className="px-4 py-2 text-right font-medium text-gray-800">
                      {t.usd?.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                    <td className="px-4 py-2 text-right font-medium text-gray-800">
                      {t.eur?.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

/* ─── Tab País y Moneda ──────────────────────────────────────────────────── */
function PaisMonedaTab() {
  const { usuario, actualizarUsuario } = useAuth();

  const [pais, setPais] = useState(usuario?.pais || "");
  const [monedaLocal, setMonedaLocal] = useState(
    usuario?.moneda_local && usuario.moneda_local !== "VES" ? usuario.moneda_local : "USD"
  );
  const [monedaManual, setMonedaManual] = useState(false);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");

  // Se basa en el país seleccionado actualmente (no en el valor guardado)
  const esVenezuela = pais === "Venezuela";

  const handlePaisChange = (nuevoPais) => {
    setPais(nuevoPais);
    if (nuevoPais === "Venezuela") {
      setMonedaLocal("VES");
    } else if (!monedaManual) {
      setMonedaLocal(PAISES_MONEDAS_CONFIG[nuevoPais] || "USD");
    }
  };

  const guardar = async () => {
    if (!pais) return;
    const monedaAGuardar = pais === "Venezuela" ? "VES" : monedaLocal;
    setSaving(true);
    setMsg("");
    try {
      await api.put("/auth/pais-moneda", { pais, moneda_local: monedaAGuardar });
      actualizarUsuario({ pais, moneda_local: monedaAGuardar });
      setMsg("¡Guardado correctamente!");
      setTimeout(() => setMsg(""), 3000);
    } catch (e) {
      setMsg(e.response?.data?.detail || "Error al guardar");
    } finally {
      setSaving(false);
    }
  };

  const monedaActual = MONEDAS_DISPONIBLES.find((m) => m.code === monedaLocal);

  return (
    <div className="space-y-6 max-w-lg">
      <div>
        <h3 className="font-semibold text-gray-800 mb-1">País y moneda del catálogo</h3>
        <p className="text-sm text-gray-500">
          Configura el país y la moneda que se muestra a tus clientes.
        </p>
      </div>

      {msg && (
        <div className={`px-4 py-3 rounded-lg text-sm ${msg.includes("Error") ? "bg-red-50 text-red-700 border border-red-200" : "bg-green-50 text-green-700 border border-green-200"}`}>
          {msg}
        </div>
      )}

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">País</label>
        <select
          value={pais}
          onChange={(e) => handlePaisChange(e.target.value)}
          className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          <option value="">Selecciona tu país</option>
          {PAISES_CONFIG.map((p) => <option key={p} value={p}>{p}</option>)}
        </select>
      </div>

      {/* Moneda: Venezuela usa BCV, los demás la eligen aquí */}
      {esVenezuela ? (
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 space-y-1">
          <p className="text-sm font-semibold text-amber-800">Moneda: Bolívar venezolano (VES)</p>
          <p className="text-xs text-amber-700">
            Tu catálogo muestra los precios en dólares (USD) con su equivalente en bolívares (Bs.)
            calculado automáticamente con la tasa del BCV.
            Para configurar la tasa y la moneda de referencia (USD / EUR), usa la pestaña{" "}
            <strong>Tasa BCV</strong>.
          </p>
        </div>
      ) : (
        <div>
          <div className="flex items-center justify-between mb-1">
            <label className="block text-sm font-medium text-gray-700">Moneda de cobro</label>
            <label className="flex items-center gap-1.5 cursor-pointer">
              <input
                type="checkbox"
                checked={monedaManual}
                onChange={(e) => setMonedaManual(e.target.checked)}
                className="rounded border-gray-300 text-indigo-600"
              />
              <span className="text-xs text-gray-500">Elegir manualmente</span>
            </label>
          </div>
          {monedaManual ? (
            <select
              value={monedaLocal}
              onChange={(e) => setMonedaLocal(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              {MONEDAS_DISPONIBLES.map((m) => (
                <option key={m.code} value={m.code}>{m.label}</option>
              ))}
            </select>
          ) : (
            <div className="flex items-center gap-3 bg-gray-50 border border-gray-200 rounded-lg px-3 py-2.5">
              <span className="text-2xl font-bold text-indigo-600">{monedaLocal}</span>
              <span className="text-sm text-gray-600">{monedaActual?.label?.split(" — ")[1] || ""}</span>
            </div>
          )}
          <p className="text-xs text-gray-400 mt-1.5">
            Los precios en tu catálogo público se mostrarán con el símbolo de esta moneda.
          </p>
        </div>
      )}

      <button
        onClick={guardar}
        disabled={saving || !pais}
        className="bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-400 text-white px-6 py-2.5 rounded-lg text-sm font-medium"
      >
        {saving ? "Guardando..." : "Guardar cambios"}
      </button>
    </div>
  );
}
